import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { Grid } from "@material-ui/core";
import { ErrorCommon, Label, TextField, TextFieldCommon } from "../formikFormInputs";
import { Formik } from "formik";
import DialogHeader from "../dialog/DialogHeader";
import DialogContent from "../dialog/DialogContent";

export default function VideoDialog(props: any) {
  const {onClose, onSave, url} = props;
  const handleClose = () => {
    onClose();
  };
  const fieldObj = [{
    id: "url",
    name: "url",
    component: TextField,
    placeholder: "Video Url",
    label: <Label label={"Video Url"} required={true}/>,
    rowSize: 6,
    fullWidth: true,
  }];

  const initialValues = {
    url: url || ""
  };

  const validate = ((value: any) => {
    const errors: any = {};
    if (!value.url.trim()) {
      errors.url = "Required";
    }
    return errors;
  });

  const submitFormik = async (values: any) => {
    onSave(values.url);
  };
  return (
    <div>
      <Dialog onClose={handleClose} fullWidth={true} maxWidth="sm" aria-labelledby="customized-dialog-title"
              open={true}>
        <DialogHeader onClose={handleClose}>
          Update Video
        </DialogHeader>
        <DialogContent dividers>
          <Formik
            initialValues={initialValues}
            validate={(values: any) => validate(values)}
            onSubmit={(values: any) => submitFormik(values)}
          >
            {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting}: any) =>
              (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    {
                      fieldObj.map((field, index) => {
                        return (
                          <Grid item xs={12} key={index}>
                            <TextFieldCommon
                              {...field}
                              values={values}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorCommon errors={errors} name={field.name} touched={touched}/>
                          </Grid>)
                      })
                    }
                  </Grid>
                  <br/>
                  <Button
                    className="floatRight mt20"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                    type="submit"
                  >
                    Update Video
                  </Button>
                </form>
              )
            }
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
